module.exports = __webpack_public_path__ + "icon_marketing_green.png?5f31dc6dd2b9db15ff1252f18b24dbd1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_marketing_green.png
// module id = 253
// module chunks = 0